import type { StripeInvoicesList } from "@/API";
import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { listInvoices } from "@/graphql/queries";

const client = generateClient();

export const listInvoicesState = create<State<StripeInvoicesList>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const getListInvoicesIsloading = () =>
  listInvoicesState.setState(() => ({
    isFetching: true,
    isLoading: true,
    data: null,
    error: null,
  }));
export const getListInvoicesIsFetching = () =>
  listInvoicesState.setState(() => ({
    isFetching: false,
    isLoading: true,
    error: null,
  }));
export const getListInvoicesIsError = (error: Error) =>
  listInvoicesState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
    isFetching: false,
  }));
export const getListInvoicesIsSuccess = (listInvoices: StripeInvoicesList) =>
  listInvoicesState.setState(() => ({
    data: listInvoices,
    isLoading: false,
    error: null,
    isFetching: false,
  }));

type GetListInvoicesParams = {
  lastInvoiceId?: string;
}

export const getListInvoices = async (params?: GetListInvoicesParams) => {
  if (params?.lastInvoiceId) getListInvoicesIsFetching();

  if (!params?.lastInvoiceId) getListInvoicesIsloading();

  try {
    const { data } = await client.graphql({
      query: listInvoices,
      variables: {
        after: params?.lastInvoiceId,
      },
    });

    if (!params?.lastInvoiceId)
      getListInvoicesIsSuccess(data.listInvoices as StripeInvoicesList);

    if (params?.lastInvoiceId)
      getListInvoicesIsSuccess({
        hasMore: data.listInvoices.hasMore,
        invoices: [
          ...(listInvoicesState.getState().data?.invoices ?? []),
          ...data.listInvoices.invoices,
        ],
      } as StripeInvoicesList);
  } catch (e) {
    const errorMessage =
      e instanceof Error ? e.message : "failed to query get incoices";
    getListInvoicesIsError(Error(errorMessage));
  }
};
